import { action, payload } from 'ts-action'
import { ITemplate } from '@network/models/template.model'
import { IError, IPayload } from '@network/models/global.model'

export const TemplateFetching = action('TemplateFetching', payload<boolean>())

export const GetTemplate = action('GetTemplate', payload<IPayload<ITemplate>>())

export const GetTemplateErrors = action('GetTemplateErrors', payload<IError>())
